import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultarNumeroMotorBin } from './types';

export const INITIAL_STATE: consultarNumeroMotorBin = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarNumeroMotorBin {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_NUMERO_MOTOR_BIN_REQUEST: {
				break;
			}

			case Types.CONSULTAR_NUMERO_MOTOR_BIN_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_NUMERO_MOTOR_BIN_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_NUMERO_MOTOR_BIN_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
